export default __webpack_public_path__ + "static/media/player-chips.066d05a4.webp";